import { Box, Heading, Image, Paragraph, TextButton } from '@zillow/constellation-10';
import zillowAndPlaidSvg from '@assets/zillow-plaid.svg';

export const VerifyBankAccount = ({ onDeletePaymentMethodClick }) => (
  <Box css={{ display: 'flex', flexDirection: 'column', gap: 'token(spacing.md)' }}>
    <Image alt="zillow-plaid" css={{ width: '100px' }} src={zillowAndPlaidSvg as unknown as string} />
    <Heading level={2} textStyle="heading-xs">
      Verify your bank account
    </Heading>
    <Paragraph>Finish verifying with Plaid, our trusted partner, to securely add your bank account.</Paragraph>
    <TextButton css={{ alignSelf: 'flex-start' }} onClick={onDeletePaymentMethodClick}>
      Remove this payment method
    </TextButton>
  </Box>
);
